import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Layout } from "antd";
import Dashboard from "./pages/Dashboard";
import DocumentGenerator from "./pages/DocumentGenerator";
import AppHeader from "./components/Header";
import Files from "./pages/Files";
import Login from "./pages/Login";
import axios from "axios";
import Companies from "./pages/Companies";

const { Content, Footer } = Layout;

// Auth-Check Wrapper
const PrivateRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/protected`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) setAuthenticated(true);
      })
      .catch(() => setAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Authentifiziere...</p>;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

// Layout nur für eingeloggte Nutzer
const ProtectedLayout = ({ collapsed, setCollapsed }) => (
  <Layout style={{ minHeight: "100vh" }}>
    <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
    <Layout className="site-layout">
      <Content style={{ margin: "16px" }}>
        <div style={{ padding: 24, minHeight: 360, background: "#fff" }}>
          <Outlet />
        </div>
      </Content>
      <Footer style={{ textAlign: "center" }}>
        Verinorm ©2025 Created by Eren Ekmekcioglu
      </Footer>
    </Layout>
  </Layout>
);

const App = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Router>
      <Routes>
        {/* Login hat KEIN Layout außenrum */}
        <Route path="/login" element={<Login />} />

        {/* Geschützte Seiten mit Layout */}
        <Route element={<PrivateRoute />}>
          <Route
            element={
              <ProtectedLayout
                collapsed={collapsed}
                setCollapsed={setCollapsed}
              />
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/generator" element={<DocumentGenerator />} />
            <Route path="/files" element={<Files />} />
            <Route path="/companies" element={<Companies />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
